import React, { useState } from "react";

import {
  Description,
  DescriptionLight,
  SubDescription,
  SubDescriptionLight,
  SubHeader,
  SubTitle,
} from "Components/CustomComponents";
import { ActivityLog } from "Data/interfaces";
import { Col, Row } from "react-bootstrap";
import { FaChevronDown } from "react-icons/fa6";
import { EMERGENCY_SERVICE, ROUTE_STOP_STATUS } from "../../constants";
import styles from "./styles/ProfileAccordian.module.scss";

interface ProfileAccordionProps {
  //   driver: Drivers;
  driver: ActivityLog; // driver with stops
  totalStops: number;
}

const ProfileAccordian: React.FC<ProfileAccordionProps> = ({
  driver,
  totalStops,
}) => {
  //   console.log(driver);
  //   console.log(totalStops);
  const [isActive, setIsActive] = useState<boolean>(true);

  return (
    <div className={styles.ProfileAccordian}>
      <div
        className={styles.profileContainer}
        onClick={() => setIsActive((prev) => !prev)}
      >
        <div className="w-100 d-flex flex-row align-items-center gap-3">
          <img src={driver.image_url} className={styles.image} alt="" />
          <div
            className={`${styles.content} d-flex flex-row align-items-center`}
          >
            <div className={`d-flex flex-column`}>
              <Description
                text={
                  <>
                    Truck No: <span className="fw-bold">{driver.truck_no}</span>
                  </>
                }
              />
              <SubTitle
                text={`${driver.firstname} ${driver.lastname}`}
                classes="mb-05 lc-1"
              />
              <SubDescription
                text={
                  <>
                    Stops <span className="fw-bold ms-1">{totalStops}</span>
                  </>
                }
              />
            </div>
          </div>
        </div>
        <div className={`${styles.button} ${isActive ? styles.open : ""}`}>
          <FaChevronDown size={25} />
        </div>
      </div>

      <div
        className={`${styles.detailsContainer} ${isActive ? styles.visible : ""
          }`}
      >
        <SubHeader text="Activity Logs" classes="my-4" />

        <div className={styles.details}>
          {driver.stops.map((stop) => {
            console.log(stop);
            // console.log(index);

            if (
              stop.status === ROUTE_STOP_STATUS.PICKEDUP ||
              stop.status === ROUTE_STOP_STATUS.NOTPICKED ||
              stop.status === ROUTE_STOP_STATUS.INCOMPLETESTOP ||
              stop.status === ROUTE_STOP_STATUS.ONTIMEPICKUP
            ) {
              return (
                <div className={styles.content} key={stop.id}>
                  <SubDescription
                    text={stop.status}
                    classes="text-danger fw-bold"
                  />
                  <DescriptionLight text={stop.customer_location} />
                  <DescriptionLight
                    text={stop.customer_notes}
                  //   classes="lc-2"
                  />
                </div>
              );
            } else if (stop.status === ROUTE_STOP_STATUS.STOPPED) {
              if (stop.route_emergency_service.ticket_number) {
                return (
                  <div className={styles.content} key={stop.id}>
                    <SubDescription
                      text={stop.route_emergency_service.issue_type || ''}
                      classes="text-danger fw-bold"
                    />
                    <SubTitle
                      text={
                        <span className="d-flex flex-row align-items-center gap-3">
                          <span>
                            Facility {stop.route_emergency_service.facility}
                          </span>
                          <span>
                            Gallon {stop.route_emergency_service.tonnage}
                          </span>
                        </span>
                      }
                      classes="fw-900 my-1"
                    />
                    <SubDescriptionLight
                      text={
                        <span className="d-flex flex-row align-items-center gap-4">
                          <span>
                            START TIME :
                            <span className="fw-bold text-black">
                              {stop.route_emergency_service.start_time}
                            </span>
                          </span>
                          <span>
                            END TIME :{" "}
                            <span className="fw-bold text-black">
                              {stop.route_emergency_service.end_time}
                            </span>
                          </span>
                        </span>
                      }
                    />
                  </div>
                );
              }
              if (stop?.route_emergency_service?.type === EMERGENCY_SERVICE.BREAKDOWN) {
                return (
                  <div className={styles.content} key={stop.id}>
                    <SubDescription
                      text={stop.route_emergency_service.issue_type || ''}
                      classes="text-danger fw-bold"
                    />
                    <span className="d-flex flex-row align-items-center gap-2">
                      <SubTitle
                        text={"Notes"}
                        classes="fw-900 my-1"
                      />
                      <span>
                        {stop.route_emergency_service.notes}
                      </span>
                    </span>
                    <SubDescriptionLight
                      text={
                        <span className="d-flex flex-row align-items-center gap-4">
                          <span>
                            START TIME :
                            <span className="fw-bold text-black">
                              {stop.route_emergency_service.start_time}
                            </span>
                          </span>
                          <span>
                            END TIME :{" "}
                            <span className="fw-bold text-black">
                              {stop.route_emergency_service.end_time}
                            </span>
                          </span>
                        </span>
                      }
                    />
                  </div>
                );
              }
              else if (stop?.route_emergency_service?.type === EMERGENCY_SERVICE.PERSONAL) {
                return (
                  <div className={styles.content} key={stop.id}>
                    <Row className="justify-content-between">
                      <Col xl={6} lg={12} sm={6}>
                        <SubDescription
                          text={stop.route_emergency_service.type || ''}
                          classes="text-danger fw-bold"
                        />
                        <DescriptionLight
                          text={stop.route_emergency_service.notes || ''}
                        //   classes="lc-2"
                        />
                      </Col>
                    </Row>
                  </div>
                )
              }
              else if (stop.route_emergency_stop.id) {
                return (
                  <div className={styles.content} key={stop.id}>
                    <Row className="justify-content-between">
                      <Col xl={6} lg={12} sm={6}>
                        <SubDescription
                          text={stop.route_emergency_stop.type || ''}
                          classes="text-danger fw-bold"
                        />
                        <DescriptionLight
                          text={stop.route_emergency_stop.notes || ''}
                        //   classes="lc-2"
                        />
                      </Col>
                      {!stop.route_emergency_stop.image_url ? "" :
                        <Col xl={6} lg={12} sm={6}>
                          <div className={styles.image}>
                            <img
                              src={stop.route_emergency_stop.image_url || ''}
                              alt="Container Image"
                            />
                          </div>
                        </Col>
                      }
                    </Row>
                  </div>
                );
              }
            } else {
              return null;
            }
          })}
          {/*  */}
          {/* <div className={styles.content}>
            <SubDescription text={"Low Fuel"} classes="text-danger fw-bold" />
            <SubTitle
              text={
                <span className="d-flex flex-row align-items-center gap-3">
                  <span>Facility 0 </span>
                  <span>Gallon 10</span>
                </span>
              }
              classes="fw-900 my-1"
            />
            <SubDescriptionLight
              text={
                <span className="d-flex flex-row align-items-center gap-4">
                  <span>
                    START TIME :{" "}
                    <span className="fw-bold text-black">07 : 30</span>
                  </span>
                  <span>
                    END TIME :{" "}
                    <span className="fw-bold text-black">07 : 30</span>
                  </span>
                </span>
              }
            />
          </div>

          <div className={styles.content}>
            <Row className="justify-content-between">
              <Col xl={6} lg={12} sm={6}>
                <SubDescription
                  text={"Exception"}
                  classes="text-danger fw-bold"
                />
                <DescriptionLight
                  text={
                    "Nolan Bator has Stop because of Road is Blocked 4:30 PM"
                  }
                />
              </Col>
              <Col xl={6} lg={12} sm={6}>
                <div className={styles.image}>
                  <img src="/images/container.png" alt="Container Image" />
                </div>
              </Col>
            </Row>
          </div>

          <div className={styles.content}>
            <DescriptionLight text={"Nolan Bator All Stops Completed"} />
                  </div> */}
        </div>
      </div>
    </div >
  );
};

export default ProfileAccordian;
